import { GameVars } from "./../../GameVars";
import { BattleScene } from "./BattleScene";
import { GameConstants } from "../../GameConstants";
import { BattleManager } from "./BattleManager";

export class SpecialAttackTutorialLayer extends Phaser.GameObjects.Container {

    private midContainer: Phaser.GameObjects.Container;
    private attackButton: Phaser.GameObjects.Image;
    private bubbleContainer: Phaser.GameObjects.Container;
    private bubble: Phaser.GameObjects.Image;
    private kingContainer: Phaser.GameObjects.Container;

    private attackType: number;
    private phase: number;

    constructor(scene: Phaser.Scene, attackType: number) {

        super(scene);

        this.attackType = attackType;
        this.phase = -1;

        const bck = new Phaser.GameObjects.Graphics(this.scene);
        bck.fillStyle(0x000000);
        bck.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        bck.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        bck.on("pointerup", () => { 
            this.nextPhase(); 
        });
        bck.alpha = 0;
        this.add(bck);

        this.midContainer = new Phaser.GameObjects.Container(this.scene);
        this.midContainer.setPosition(GameConstants.GAME_WIDTH / 2, 0);
        this.midContainer.scaleX = this.scene.sys.game.device.os.desktop ? 1 : GameVars.scaleX + GameVars.contrascaleX;
        this.add(this.midContainer);

        let scaleX = this.scene.sys.game.device.os.desktop ? 1 : (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX;

        this.kingContainer = new Phaser.GameObjects.Container(this.scene);
        this.kingContainer.setPosition(this.attackType === 0 ? -310 : 310, GameConstants.GAME_HEIGHT + 450);
        this.kingContainer.scaleX = scaleX;
        this.midContainer.add(this.kingContainer);

        const king = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "king-tutorial");
        king.setOrigin(.5, 1);
        this.kingContainer.add(king);

        const kingHand = new Phaser.GameObjects.Image(this.scene, -140, -10, "texture_atlas_5", "table_background_07");
        kingHand.setOrigin(.5, 1);
        this.kingContainer.add(kingHand);

        this.bubbleContainer = new Phaser.GameObjects.Container(this.scene);
        this.bubbleContainer.setPosition(this.attackType === 0 ? -10 : 10, GameConstants.GAME_HEIGHT - 230);
        this.bubbleContainer.setScale(0);
        this.bubbleContainer.setAlpha(0);
        this.midContainer.add(this.bubbleContainer);

        this.bubble = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "speech-bubble");
        this.bubble.scaleX = this.attackType === 0 ? 1 : -1;
        this.bubbleContainer.add(this.bubble);

        let text = "";

        if (this.attackType === 0) {
            text = "A heckload of enemies are approaching. We'll make use of a TSUNAMI OF TAR and my wave riding skills to slow them down.";
        } else {
            text = "We are short of MONEY! Let's think... There's those PIGS and here's plenty of DYNAMITE... BOOYAH!";
        }

        const bubbleText = new Phaser.GameObjects.Text(this.scene, this.attackType === 0 ? 5 : -5, 0, text, {fontFamily: "Rubik-Bold", fontSize: "24px", color: "#563744", align: "center"});
        bubbleText.setOrigin(.5);
        bubbleText.setWordWrapWidth(420);
        this.bubbleContainer.add(bubbleText);

        if (this.attackType === 0) {
            this.attackButton = new Phaser.GameObjects.Image(this.scene, -60, GameConstants.GAME_HEIGHT - 60, "texture_atlas_1", "btn_skill_slow_idle");
            this.attackButton.setInteractive();
            
            this.attackButton.on("pointerup", () => { 
                this.onClickFreezeAttack(); 
            });
            this.attackButton.on("pointerdown", () => {
                this.attackButton.setFrame("btn_skill_slow_pressed");
            });
            this.attackButton.on("pointerout", () => { 
                if (this.attackButton.input.enabled) {
                    this.attackButton.setFrame("btn_skill_slow_idle");
                }
            });
            this.attackButton.on("pointerover", () => { 
                this.attackButton.setFrame("btn_skill_slow_over");
            });
        } else {

            this.attackButton = new Phaser.GameObjects.Image(this.scene, 60, GameConstants.GAME_HEIGHT - 60, "texture_atlas_1", "btn_skill_pig_idle");
            this.attackButton.setInteractive();

            this.attackButton.on("pointerup", () => { 
                this.onClickSuicideAttack(); 
            });
            this.attackButton.on("pointerdown", () => {
                this.attackButton.setFrame("btn_skill_pig_pressed");
            });
            this.attackButton.on("pointerout", () => { 
                if (this.attackButton.input.enabled) {
                    this.attackButton.setFrame("btn_skill_pig_idle");
                }
            });
            this.attackButton.on("pointerover", () => {
                this.attackButton.setFrame("btn_skill_pig_over");
            }); 
        }

        this.attackButton.setScale(0);
        this.attackButton.setAlpha(0);
        this.midContainer.add(this.attackButton);

        this.scene.tweens.add({
            targets: bck,
            alpha: .75,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500
        });

        this.scene.tweens.add({
            targets: this.kingContainer,
            y: GameConstants.GAME_HEIGHT + 50,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250,
            delay: 500
        });

        this.scene.tweens.add({
            targets: this.kingContainer,
            y: GameConstants.GAME_HEIGHT + 50,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250,
            delay: 500
        });

        this.scene.tweens.add({
            targets: this.bubbleContainer,
            scaleX: scaleX,
            scaleY: 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 250,
            delay: 1000
        });

        this.scene.tweens.add({
            targets: this.bubbleContainer,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250,
            delay: 1000,
            onComplete: () => {
                this.phase = 0;
            },
            onCompleteScope: this
        });
    }

    public nextPhase(): void {

        if (this.phase === 0) {

            let scaleX = this.scene.sys.game.device.os.desktop ? 1 : (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX;

            this.scene.tweens.add({
                targets: this.kingContainer,
                y: this.kingContainer.y + 400,
                ease: Phaser.Math.Easing.Cubic.In,
                duration: 250
            });

            this.scene.tweens.add({
                targets: this.bubbleContainer,
                scaleX: 0,
                scaleY: 0,
                ease: Phaser.Math.Easing.Back.In,
                duration: 250
            });

            this.scene.tweens.add({
                targets: this.bubbleContainer,
                alpha: 0,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 250,
                onComplete: () => {
                    this.phase++;
                },
                onCompleteScope: this
            });

            this.scene.tweens.add({
                targets: this.attackButton,
                scaleX: scaleX,
                scaleY: 1,
                ease: Phaser.Math.Easing.Back.Out,
                duration: 250,
                delay: 500
            });

            this.scene.tweens.add({
                targets: this.attackButton,
                alpha: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 250,
                delay: 500
            });

            const handCursor = new Phaser.GameObjects.Image(this.scene, this.attackButton.x, this.attackButton.y - 120, "texture_atlas_1", "hand-cursor");
            handCursor.setScale(0);
            handCursor.setAlpha(0);
            this.midContainer.add(handCursor);

            this.scene.tweens.add({
                targets: handCursor,
                scaleX: scaleX,
                scaleY: -1,
                ease: Phaser.Math.Easing.Back.Out,
                duration: 250,
                delay: 500
            });

            this.scene.tweens.add({
                targets: handCursor,
                alpha: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 250,
                delay: 500
            });

            this.scene.tweens.add({
                targets: handCursor,
                y: handCursor.y + 10,
                ease: Phaser.Math.Easing.Linear,
                delay: 750,
                duration: 400,
                repeat: -1,
                yoyo: true
            });

            this.phase++;
        }  
    }

    private onClickFreezeAttack(): void {

        BattleManager.resume();
        BattleScene.currentInstance.gui.specialAttacks.onClickFreezeAttack();
        this.destroy();
    }

    private onClickSuicideAttack(): void {

        BattleManager.resume();
        BattleScene.currentInstance.gui.specialAttacks.onClickSuicideAttack();
        this.destroy();
    }
}
